import Box from '@/common/components/Box';
import useProduct from '@/features/products/hooks/useProduct';
import { Trash } from 'lucide-react';
import { ConsumptionValidationSchema } from '../schemas/create.schema';
import { Controller, FieldArray, useFormContext } from 'react-hook-form';
import { options as unityForQuantity } from "@/common/constants/unitForQuantityOptions";
import { useEffect, useState } from 'react';
import { CurrencyTextField } from '@/common/components/CurrencyTextField';
import { UnitTextField } from '@/common/components/UnitTextField';

interface ProductItemProps {
  index: number;
  field: FieldArray<ConsumptionValidationSchema, "line_items_attributes">;
  onDelete: () => void;
}

const ProductItem = ({ index, field, onDelete }: ProductItemProps) => {
  const {
    control,
    register,
    watch,
    formState: { errors },
  } = useFormContext<ConsumptionValidationSchema>();

  const { data: product } = useProduct(field.product_id);

  const [unitSymbol, setUnitSymbol] = useState("");

  useEffect(() => {
    if (product) {
      const unit = unityForQuantity.filter((unit) => unit.value === product.unit_for_quantity)[0];

      setUnitSymbol(unit.symbol);
    }
  }, [product?.id]);

  return (
    <Box className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <p className="text-[18px]">{product?.display_name}</p>

        <Trash strokeWidth={1} className='cursor-pointer' color="var(--warning)" onClick={() => onDelete()} />
      </div>

      <div className="flex gap-6">
        <div className="grow">
          <UnitTextField
            data-testid={`unit_text_${index}`}
            unit={unitSymbol}
            label="Quantidade"
            errorMessage={errors?.line_items_attributes?.[index]?.quantity?.message}
            defaultValue={`${watch(`line_items_attributes.${index}.quantity`)} ${unitSymbol}`}
            {...register(`line_items_attributes.${index}.quantity`)}
          />
        </div>

        <div className="grow">
          <Controller
            name={`line_items_attributes.${index}.unitary_amount`}
            control={control}
            render={({ field, formState }) => (
              <CurrencyTextField
                data-testid={`currency_text_${index}`}
                label="Valor unit."
                errorMessage={formState.errors?.line_items_attributes?.[index]?.unitary_amount?.message}
                {...field}
              />
            )}
          />
        </div>
      </div>
    </Box>
  );
};

export default ProductItem;
